import type { FeatureCollection } from 'geojson'

import type { OperationalLayerRow } from '../types'

function isFeatureCollection(value: unknown): value is FeatureCollection {
  return (
    typeof value === 'object' &&
    value !== null &&
    (value as FeatureCollection).type === 'FeatureCollection' &&
    Array.isArray((value as FeatureCollection).features)
  )
}

export function normalizeLayerGeoJSON(
  layer: OperationalLayerRow,
): FeatureCollection | null {
  const raw = layer.data
  if (raw == null) return null

  try {
    const parsed: unknown =
      typeof raw === 'string' ? (JSON.parse(raw) as unknown) : raw
    if (!isFeatureCollection(parsed)) return null
    return parsed
  } catch (err) {
    console.warn('[smart-search] Invalid GeoJSON for layer', layer.id, err)
    return null
  }
}
